import styled from 'styled-components';
import { WppIconDownload, WppTypography } from '@wppopen/components-library-react';

export const Main = styled.div`
    display: flex;
    row-gap: 32px;
    column-gap: 32px;
`;

export const MainWrapper = styled.div`
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: minmax(32px, min-content) minmax(32px, min-content) auto;
    row-gap: 9px;
    min-height: 728px;
    height: auto;
    width: calc(100% - 296px - 32px);
    border-radius: 12px;
    background-color: white;
    padding: 24px;
    box-shadow: var(--wpp-box-shadow);
    position: relative;
`;

export const MainLoader = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const MainHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const MainDownload = styled(WppIconDownload)`
    cursor: pointer;
`;

export const MainTitle = styled.div`
    display: flex;
    column-gap: 24px;
    align-items: center;
`;

export const LearnMore = styled(WppTypography)<{
    isLearnMoreShown: boolean;
}>`
    display: ${({ isLearnMoreShown }) => (isLearnMoreShown ? 'flex' : 'none')};
    cursor: pointer;
    color: #4d5358;
    width: 80px;
    padding: 0;
    &:hover {
        text-decoration: underline;
    }
`;
